import React, { useEffect } from "react";
import "./error-banner.scss";

function ErrorBanner({ message, onClose, autoClose = true, duration = 5000 }) {
  useEffect(() => {
    if (autoClose && message) {
      const timer = setTimeout(() => onClose && onClose(), duration);
      return () => clearTimeout(timer);
    }
  }, [message, autoClose, duration, onClose]);

  if (!message) return null;

  return (
    <div className={`error-box ${message ? 'fade-in' : 'fade-out'}`}>
      <i className="fa-solid fa-circle-exclamation error-icon"></i>
      <span className="error-text">{message}</span>
      {onClose && (
        <button className="error-close" onClick={onClose}>
          <i className="fa-solid fa-xmark"></i>
        </button>
      )}
    </div>
  );
}

export default ErrorBanner;
